import _ from "lodash";
import { getDate, getItemsWithinDateRange, parseDate } from "./dateHelpers.js";
import { escapeHtml, escapeText, htmlToXML } from "./frontendUtilities.js";
import {
  clone,
  empty,
  getField,
  getKey,
  isFunction,
  removeSpecialChar
} from "./utilities.js";

export function projectRole(opts) {
  opts = opts || {};

  return function (item, i, cvDef, genOpts) {
    var role = "";
    var directCosts = "";
    if (item.role != null && item.role != "Not Selected") role = item.role;

    // Aliases
    role =
      {
        "Principal Investigator": "PI",
        "Co-Principal Investigator": "Co-PI",
        "Multi-Principal Investigator": "MPI",
        "Site Principal Investigator": "Site PI",
        "Project Principal Investigator": "Project PI",
        "Sub-Contract Principal Investigator": "Sub-Contract PI"
      }[role] || role;

    var noDirectCosts = !!genOpts?.customExportSettings?.directCostsShown;
    if (
      !noDirectCosts &&
      item.directCosts != null &&
      (item.type == "submitted" || item.type == "funded")
    )
      directCosts = item.directCosts;

    var isPI =
      role.toLowerCase().indexOf("principal investigator") >= 0 ||
      /\bpi\b/.test(role.toLowerCase());
    var isMPI =
      isPI &&
      ["multi", "mpi"].some(function (key) {
        return role.toLowerCase().indexOf(key) >= 0;
      });
    var isCoPI =
      isPI &&
      ["co ", "co-"].some(function (key) {
        return role.toLowerCase().indexOf(key) >= 0;
      });
    var isSiteOrProjectPI =
      isPI &&
      ["site ", "project "].some(function (key) {
        return role.indexOf(key) >= 0;
      });

    var piName = (item.piName || "").trim();

    var parenItems = [];
    if (piName != "" && !opts.noPI)
      parenItems.push(
        (isMPI
          ? "MPI"
          : isSiteOrProjectPI
            ? "Overall PI"
            : isCoPI
              ? "Co-PI"
              : "PI") +
          ": " +
          piName
      );
    if (directCosts != "" && !opts.noCosts)
      parenItems.push((/\d/.test(directCosts[0]) ? "$" : "") + directCosts);

    return (
      (opts.prefix == null ? "" : opts.prefix) +
      role +
      " " +
      (parenItems.length == 0 ? "" : "(" + parenItems.join(", ") + ")")
    );
  };
}

export function getExtraPINameField(opts) {
  opts = opts || {};
  return {
    required: true,
    width: 200,
    height: 30,
    name: "piName",
    label: function (item) {
      var role = (item.role || "").toLowerCase();
      var isPI =
        role.indexOf("principal investigator") >= 0 || /\bpi\b/.test(role);
      var isCoPI =
        isPI &&
        ["co-", "co ", "multi"].some(function (key) {
          return role.indexOf(key) >= 0;
        });
      var isSiteOrProjectPI =
        isPI &&
        ["site ", "project "].some(function (key) {
          return role.indexOf(key) >= 0;
        });
      if (item.role == "Multi-Principal Investigator") return "MPI Name";
      if (item.role == "Co-Principal Investigator") return "Co-PI Name";
      return isSiteOrProjectPI ? "Overall PI" : isCoPI ? "Other PI" : "PI Name";
    },
    filter: function (item) {
      if (opts.filter != null && !opts.filter(item)) return false;
      var role = (item.role || "").toLowerCase();
      var isPI =
        role.indexOf("principal investigator") >= 0 || /\bpi\b/.test(role);
      var isCoPI =
        isPI &&
        ["co-", "co ", "multi"].some(function (key) {
          return role.indexOf(key) >= 0;
        });
      var isSiteOrProjectPI =
        isPI &&
        ["site ", "project "].some(function (key) {
          return role.indexOf(key) >= 0;
        });
      return (
        !isPI ||
        isCoPI ||
        isSiteOrProjectPI ||
        (item.piName || "").trim().length > 0
      );
    }
  };
}

var getPMIDduplicate = function (item, newDef, types) {
  var PMID = item.PMID || "";
  var sectionDef = newDef.lists.scholarship;
  var dupItem = null;
  if (PMID != null) {
    for (var id in sectionDef) {
      var otherItem = sectionDef[id];
      if (
        otherItem != null &&
        otherItem.PMID == PMID &&
        id != item.id &&
        types.indexOf(otherItem.type) >= 0
      ) {
        dupItem = clone(otherItem);
        dupItem.id = id;
        break;
      }
    }
  }
  return dupItem;
};
export { getPMIDduplicate };

var isPMIDCitationUpdated = function (item) {
  const isUpdated = [
    "Author Correction",
    "Correction",
    "Retraction",
    "Corrigendum",
    "Author’s Reply"
  ].some(function (type) {
    return item.line?.includes(type);
  });
  return isUpdated;
};
export { isPMIDCitationUpdated };

var scholarshipAdvancedImportTrim = function (text, item) {
  text = text.replace(/^(?:\(\t| )*\d+(?:\.|\)|\t| )*/g, ""); // Remove any # before
  text = text.trim();
  if (text.slice(-1) == ",") text = text.slice(0, -1);
  if (
    text
      .replace(/<[^\<]*>/g, "")
      .replace(/^(?:\(\t| )*\d+(?:\.|\)|\t| )*/g, "")
      .trim().length == 0
  )
    return "";

  // Look for dates / years. /\d{4} ?\w*/
  var potentialDates = text
    .split(/(?:(?:doi\: )|(?:https\:\/\/doi))(?:(?:\w|\.|\/)+)/)
    .join("")
    .match(/\b(\d{4} ?[a-zA-Z]*)(?!\d)/gi); // Okay to grab the first
  var potentialDate = (potentialDates || []).find(function (txt) {
    return !empty(parseDate(txt)[0]?.start);
  });
  if (potentialDate != null) {
    potentialDate = parseDate(potentialDate)[0];
    item.time = potentialDate;
  }

  return text;
};
export { scholarshipAdvancedImportTrim };
/**
 *
 * @param { string } innerName
 * @param {*} item
 * @param { { noXML: boolean
 *          }} genOpts
 * @param { { groupDetails: { richDate: boolean},
 *            details: { richDate: boolean } ,
 *            outputSource: { outputSettings: { font: string, fontSize: string }},
 *            links: { lastId: number, set: {} }
 *        } } opts
 * @returns { string }
 */
var getResKey = function (innerName, item, genOpts, opts) {
  opts = opts || {};
  if (
    [
      "monthAndFullYear",
      "monthRange",
      "yearRange",
      "limitedMonthAndFullYear",
      "limitedMonthRange",
      "limitedMonthDayYear",
      "fullMonthDayYear",
      "mdy"
    ].indexOf(innerName) >= 0
  ) {
    var dateText = getDate(item, innerName, genOpts);

    var richDate =
      (!!(opts.groupDetails || {}).richDate ||
        !!(opts.details || {}).richDate) &&
      !genOpts.noXML;

    return !richDate
      ? dateText
      : htmlToXML(dateText, {
          font: opts.outputSource.outputSettings.font,
          fontSize: opts.outputSource.outputSettings.fontSize,
          links: opts.links
        });
  } else if (innerName == "space") {
    return "";
  } else if (innerName == "effort") {
    // Should we be passing opts into getEffortText to be able
    // to suppress worktime?
    return removeSpecialChar(getEffortText(item));
  } else {
    return getText(item, innerName, { noEscape: true, noNL: true });
  }
};
export { getResKey };

//We can globally add sufixes to the end of the text
//We can add bold and underline.
/**
 *
 * @param { { key?: string,
 *            prefix?:string,
 *            suffix?:({}) => string|string,
 *            filter?: function,
 *            time?: "monthAndFullYear"|
 *                    "monthRange"|
 *                     "yearRange"|
 *                     "limitedMonthAndFullYear"|
 *                     "limitedMonthRange"|
 *                     "limitedMonthDayYear"|
 *                     "mdy"
 *            resetFormatting?:boolean,
 *            bold?:boolean,
 *            underline?:boolean }[] }  keyList (list of keys to merge)
 * @param { { suffix?:({}) => string|string,
 *            delim?: string } } opts
 * @returns { (item:{[key:string]:string}, i: number, cvDev: {}, genOpts: {} ) => string }
 */
export function mergeItems(keyList, opts) {
  opts = opts || {};
  return function (item, i, cvDef, genOpts) {
    return (
      keyList
        .map(function (n) {
          if (n.filter != null && !n.filter(item)) return null;
          // Should this be passing in opts in order for getResKey to be able
          // to pass it to getEffortText to suppress worktime?
          var val = getResKey(n.key || n.time, item, {});
          if (val == null || val == "Not Selected" || val.trim() == "")
            return null;
          var text =
            (n.prefix != null ? n.prefix : "") +
            val +
            (n.suffix == null
              ? ""
              : isFunction(n.suffix)
                ? n.suffix(item)
                : n.suffix);
          if (n.resetFormatting)
            text = htmlToXML(text, { justText: true }).trim();
          if (n.bold) text = "<b>" + text + "</b>";
          if (n.underline) text = "<u>" + text + "</u>";
          return text;
        })
        .filter(function (n) {
          return n != null;
        })
        .join(opts.delim ?? ", ") +
      (opts.suffix == null
        ? ""
        : isFunction(opts.suffix)
          ? opts.suffix(item)
          : opts.suffix)
    );
  };
}

export function getIndex(item, i, newDef, genOpts) {
  return "" + (i + 1) + ".";
}

/**
 *
 * @param { object } item
 * @param { number } i
 * @param { import("@easycv/common/types/cv").CV } newDef
 * @param {string} section
 * @param {string[]?} types
 * @returns
 */
export function getReverseIndex(item, i, newDef, section, types = null) {
  /**
   * @type {string[]}
   */
  let includeTypes;
  if (types == null) {
    includeTypes = [item.type];
  } else {
    includeTypes = types;
  }

  const length = Object.values(newDef.lists[section]).filter((o) =>
    includeTypes.includes(o?.type)
  ).length;
  return "" + (length - i) + ".";
}

export function getCitation(name, citOpts) {
  citOpts = citOpts || {};
  return function (item, i, cvDef, genOpts) {
    genOpts = genOpts || {};
    var text =
      citOpts.getText != null
        ? citOpts.getText(item)
        : (citOpts.prefix != null ? citOpts.prefix : "") +
          getText(item, name, { noNL: true, noEscape: true }) +
          (citOpts.suffix != null ? citOpts.suffix : "");

    var pmidList = genOpts.contextState.pmidList;

    var citationInclusions = [];
    if (
      genOpts?.contextState?.customExportSettings != null &&
      item.PMID != null &&
      pmidList[item.PMID] != null
    ) {
      if (genOpts.contextState.customExportSettings?.includeCitations) {
        citationInclusions.push(
          pmidList[item.PMID].citationCount +
            " citation" +
            (pmidList[item.PMID].citationCount != 1 ? "s" : "")
        );
      }
      if (
        !!genOpts.contextState.customExportSettings?.includeRCR &&
        pmidList[item.PMID].rcr != null
      ) {
        citationInclusions.push("RCR: " + pmidList[item.PMID].rcr);
      }
    }

    if (citationInclusions.length > 0) {
      text += " [" + citationInclusions.join(", ") + "]";
    }

    if (item.PMID && genOpts.contextState?.customExportSettings?.linkPMIDs) {
      text += ` <a href="https://pubmed.ncbi.nlm.nih.gov/${item.PMID}">Link to PubMed</a>`;
    }

    var outputSettings = (genOpts.outputSource || {}).outputSettings || {};
    var fontSize =
      citOpts.fontSize != null ? citOpts.fontSize : outputSettings.fontSize;
    var font = citOpts.font != null ? citOpts.font : outputSettings.font;

    return htmlToXML(text, {
      noXML: genOpts.noXML,
      fontSize: fontSize,
      font: font,
      citationNames: genOpts.citationNames
    });
  };
}

export function getFormatted(name, opts) {
  opts = opts || {};
  return function (item, i, newDef, genOpts) {
    genOpts = genOpts || {};
    var text = (
      (opts.prefix != null ? opts.prefix : "") +
      getText(item, name, { noNL: true, noEscape: true })
    ).trim();
    if (text.length == 0) return "";

    if (genOpts.noXML) return text.split("\n").join("<br>");
    var outputSettings = (genOpts.outputSource || {}).outputSettings || {};
    var fontSize =
      opts.fontSize != null ? opts.fontSize : outputSettings.fontSize;
    var font = opts.font != null ? opts.font : outputSettings.font;

    return htmlToXML(text, {
      font: font,
      fontSize: fontSize,
      indent: opts.indent
    });
  };
}

export function previewSection(secList, title, keyList) {
  if (!Array.isArray(secList)) secList = [secList];
  let sectionName = secList.slice(-1)[0];
  const sectionIndex = sectionName.indexOf("Section");
  if (sectionIndex != -1) {
    sectionName = sectionName.substring(0, sectionIndex);
  }
  return function (def, opts) {
    opts = opts || {};
    if (opts.toggles) return { section: true, title, secList, keyList };
    if (keyList == null) {
      if (
        secList.some(function (sec) {
          return !def[sec];
        })
      )
        return null;
      var section =
        title == null
          ? ""
          : '<h5 style="text-decoration: underline;">' +
            escapeHtml(title, { allowTags: true }) +
            "</h5>";
      if ((def[sectionName + "Pre"] || "") != "")
        section +=
          escapeHtml((def[sectionName + "Pre"] || "").replace(/^\n+/, ""), {
            allowTags: true
          })
            .split("\n")
            .join("<br>") + "<br>";
    } else {
      if (
        secList.concat(sectionName + "Section").some(function (sec) {
          return !def[sec];
        })
      )
        return null;
      var section = title == null ? "" : "<h5>" + title + "</h5>";
      if ((def[sectionName + "Pre"] || "") != "")
        section +=
          escapeHtml((def[sectionName + "Pre"] || "").replace(/^\n+/, ""), {
            allowTags: true
          })
            .split("\n")
            .join("<br>") + "<br>";

      var linkKey =
        keyList.find(function (key) {
          return ["t", "time"].indexOf(key) >= 0;
        }) || keyList[0];
      section +=
        keyList == null
          ? ""
          : '<table style="width: 100%;">' +
            (def[sectionName] || [])
              .map(function (item) {
                return (
                  "<tr>" +
                  (keyList || [])
                    .map(function (key, i) {
                      if (item[key] == null) debugger;
                      var text = escapeHtml(item[key] || "", {
                        allowTags: true
                      })
                        .split("\n")
                        .join("<br>");
                      if (item.id == null && item.field == null) debugger; //
                      if (key == linkKey)
                        return (
                          '<td style="vertical-align: top;">' +
                          '<a href="#" class="jump" data-id="' +
                          item.id +
                          '" data-field="' +
                          item.field +
                          '">' +
                          text +
                          "</a>" +
                          "</td>"
                        );
                      return "<td>" + text + "</td>";
                    })
                    .join("") +
                  "</tr>"
                );
              })
              .join("") +
            "</table>";
    }

    return section;
  };
}

export function previewSections(sectionName, keyList) {
  return function (def, opts) {
    opts = opts || {};
    var sectionList = def[sectionName];
    if (!def[sectionName]) return null;
    if (opts.toggles)
      return { sections: true, sectionName, keyList, sectionList };
    return sectionList
      .map(function (sectionItem) {
        var section =
          "<h5>" + escapeHtml(sectionItem.title, { allowTags: true }) + "</h5>";
        if (sectionItem.pre != "")
          section +=
            escapeHtml(sectionItem.pre, { allowTags: true })
              .split("\n")
              .join("<br>") + "<br>";
        if ((sectionItem.c || []).length > 0) {
          var linkKey =
            (keyList || []).find(function (key) {
              return ["t", "time"].indexOf(key) >= 0;
            }) || keyList[0];
          section +=
            keyList == null
              ? ""
              : "<table>" +
                (sectionItem.c || [])
                  .map(function (item) {
                    return (
                      "<tr>" +
                      (keyList || [])
                        .map(function (key, i) {
                          var text = escapeHtml(item[key], { allowTags: true })
                            .split("\n")
                            .join("<br>");
                          if (item.id == null || item.field == null) debugger;
                          if (key == linkKey)
                            return (
                              "<td>" +
                              '<a href="#" class="jump" data-id="' +
                              item.id +
                              '" data-field="' +
                              item.field +
                              '">' +
                              text +
                              "</a>" +
                              "</td>"
                            );
                          return "<td>" + text + "</td>";
                        })
                        .join("") +
                      "</tr>"
                    );
                  })
                  .join("") +
                "</table>";
        }
        return section;
      })
      .join("");
  };
}

export function serialize(keyList, delim) {
  delim = delim || ", ";
  return function (item, subItem) {
    item = item || {};
    return keyList
      .map(function (key) {
        if (isFunction(key)) return key(item, subItem);
        return (subItem || {})[key] || item[key];
      })
      .filter(function (n) {
        return (n || "").trim().length > 0;
      })
      .join(delim);
  };
}

/**
 *
 * @param { { time?: { start?: { year?: string } } } } n
 * @param { number } numYears
 * @returns { boolean }
 */
var isUnderXYearsAgo = function (n, numYears) {
  return (
    n.time == null ||
    (n.time.start != null &&
      n.time.start.year != null &&
      parseInt(n.time.start.year) >= new Date().getFullYear() - numYears)
  );
};
export { isUnderXYearsAgo };

/**
 *
 * @param { { filter?: (item: {[key:string]: string|{}}) => boolean ,
 *            addon?: (item: {[key:string]: string|{}}) => string}} opts
 * @returns { (item: {[key:string]: string|{}}, id: string, list?: {id: string}[], sectionListOrder:{}[] ) => string }
 */
export function getCitationLabel(opts) {
  opts = opts || {};
  return function (item, id, list, sectionListOrder) {
    if (list == null) return "Citation";

    list = list || [];
    sectionListOrder = sectionListOrder || [];

    var listObj = {};
    list.map(function (n) {
      listObj[n.id] = n;
    });
    var orderedList =
      sectionListOrder != null
        ? sectionListOrder
        : list.map(function (n) {
            return n.id;
          });
    var i = orderedList.indexOf(id);

    var sublist = orderedList.slice(0, i + 1).filter(function (id) {
      return (
        listObj[id] != null &&
        listObj[id].type == item.type &&
        (opts.filter == null || opts.filter(listObj[id]))
      );
    });

    const sentences = [];

    if (sublist.indexOf(id) !== -1) {
      sentences.push("Citation " + sublist.length);
    }

    if (opts.addon) {
      sentences.push(opts.addon(item));
    }

    if (sentences.length === 0) {
      return "Citation (Citation names are automatically bolded when the CV is downloaded)";
    }
    return `${sentences.join(". ")} (Citation names are automatically bolded when the CV is downloaded)`;
  };
}

var locationTips =
  "The designations of local, regional, national, or international below are based on both the proximity of the activities to the institution at which you were appointed at that time, as well as the source of the invitation to speak/teach. Please note, <u>designation is based on the institution/organization that hosted/arranged the activity or event, not on the affiliations of those attending or participating in the activity/event.</u> For example, Harvard-hosted events that attract international attendees would still be considered local.<br><br><b>Local activities and roles:</b><ul><li>During the time of appointment at Harvard, includes activities and roles at or arranged by Harvard and any of its affiliated institutions (e.g., while a MEE faculty member, invitations to speak at BIDMC would be considered local.)</li><li>Activities and roles at institutions not directly affiliated with Harvard, but affiliated with a Harvard partner organization (e.g., an “affiliate of an affiliate”) should be considered local for those faculty who spend at least some time working onsite at that location.</li><li>Activities organized through a local-international partnership (e.g., a program organized by both a Harvard affiliate and a separate international organization), even those taking place outside of the U.S., should still be considered local. </li><li>For candidates previously appointed at other institutions, local activities and roles during the time of those appointments would include activities at or arranged by the institution(s) at which the candidate was appointed (e.g., while Associate Professor at UCSF, presentations at San Francisco General Hospital would be considered local).</li></ul><b>Regional activities and roles:</b><ul><li>During the time of appointment at Harvard, includes activities and roles based on invitations by New England institutions apart from Harvard and its affiliates. New England is defined as including the six New England states (Massachusetts, Rhode Island, Connecticut, Maine, New Hampshire and Vermont). For example, presentations at Northeastern University or Brandeis University while a faculty member at Harvard would be considered regional presentations.</li><li>For candidates previously appointed at other institutions, regional activities and roles during the time of those appointments would include activities based on invitations by institutions in regions geographically near the institution(s) at which the candidate was appointed. For example, if the candidate was appointed at an institution in Philadelphia, talks in Pennsylvania, New Jersey, or Delaware at locations other than the home institution would be considered regional. It is understood that the definition of “regional” is inexact in such cases; the candidate should make the best approximation possible.</li></ul><b>National activities and roles:</b><ul><li>During the time of appointment at Harvard, this includes activities and roles in the US, based on invitations from institutions outside the six New England states.</li><li>For candidates previously appointed at other institutions in the US, national activities and roles during the time of those appointments would include activities in the US, but outside the regional area in which the candidate was appointed.</li><li>If a national meeting happens to be held within your local or regional area, include it as a national activity, not a local or regional one, if you are invited by the national organization.</li></ul><b>International activities and roles:</b><ul><li>During the time of appointment at Harvard, includes activities and roles outside the US based on invitations by international organizations not affiliated with Harvard.</li><li>For candidates previously appointed at other institutions, international activities and roles would be those outside the country in which the candidate was appointed at that time.</li><li>If an international meeting happens to be held in the US, including Boston, or within your previous local, regional or national area, include it as international activity, not a local, regional or national one, if you are invited by the international organization.</li><li>Presentations should be considered international if annual meetings for the organization are periodically held outside North America.</li></ul>For candidates previously appointed at institutions outside the US, local, regional, national and international contributions are categorized relative to the appointing institution at that time. For example, for an individual who previously held an appointment at the University of Vienna, any talks given at that institution during the time of the appointment would be considered local, while talks given in Boston during the same time would be considered international.For individuals whose primary appointment is at Harvard, but who simultaneously hold nonvoting appointments at other institution(s), presentations at those other institutions and their affiliates should be reported as local contributions.<br><br>For individuals whose primary appointment is at Harvard, but who simultaneouslyhold nonvoting appointments at other institution(s), presentations at those other institutions and their affiliates should be reported as local contributions.";
export { locationTips };

// Need to generalize across format
var serverACGMEResult = function (newDef, startDate, endDate) {
  var ACGME_result = {};
  var filteredFields = {
    committeeService: [], // Leadership + Committees (no types)
    adminService: [], // Leadership + Committees (no types) - umass
    publicPolicy: [], // Leadership ('leadership')
    editorialActivities: [], // Leadership (no types)
    investigationLeadership: [], // Leadership (no types)
    administrativePositions: [], // Leadership (no types)

    projects: [], // grantsLed (using PI in role), grants
    teaching: [], // teaching, type filter
    presentations: [], // abstractsAndPresentations + otherPresentations (uses invitedProfessorship, presType), teaching involvement
    // scholarship: [], // PMIDs, nonPMIDs, otherPubs, abstractsAndPresentations, otherPresentations, research involvement, reviews involvement (uses type)

    teachingAndEducationInnovations: [], // innovations (no types)
    technologyAndScienceInnovations: [], // innovations (no types)
    clinicalActivityAndInnovations: [] // innovations ('Clinical Innovations')
  };

  for (var key in filteredFields)
    filteredFields[key] = getItemsWithinDateRange(
      getField(newDef, key),
      startDate,
      endDate
    );

  filteredFields["scholarship"] = getItemsWithinDateRange(
    getField(newDef, "scholarship"),
    startDate,
    endDate,
    { ignoreEnd: true }
  );

  var dateRange =
    new Date(startDate).getFullYear() + "-" + new Date(endDate).getFullYear();
  var acgmeEdits = getKey(getKey(newDef, "acgmeEdits", {}), dateRange, {
    dateRange: dateRange,
    selectOverrides: {},
    additionalCounts: {}
  });

  var additionalCounts = acgmeEdits.additionalCounts || {};
  var selectOverrides = acgmeEdits.selectOverrides || {}; // Can only move things to yes

  ACGME_result.endResult = {};

  ACGME_result.PMIDs = _.map(
    filteredFields["scholarship"].filter(function (item) {
      return item.PMID != null;
    }),
    "PMID"
  );

  getKey(acgmeEdits, "PMIDs", []);
  ACGME_result.endResult.PMIDs = _.uniq(
    (acgmeEdits.PMIDs || [])
      .filter(function (PMID) {
        return PMID != "" && PMID != null;
      })
      .concat(ACGME_result.PMIDs)
  ).slice(0, 4);

  ACGME_result.nonPMIDs = filteredFields["scholarship"].filter(function (item) {
    var types = [
      "Research Investigations",
      "Other peer-reviewed scholarship",
      "Scholarship without named authorship",
      "otherPeer",
      "abstracts"
    ];
    return types.indexOf(item.type) >= 0 && item.PMID == null;
  });
  ACGME_result.endResult.nonPMIDs =
    ACGME_result.nonPMIDs.length +
    getKey(additionalCounts, "Non-PMID Peer Review Publications", 0);

  ACGME_result.otherPubs = filteredFields["scholarship"].filter(
    function (item) {
      var types = [
        "Proceedings of meetings or other non-peer reviewed scholarship",
        "Case reports",
        "Letters to the Editor",
        "Clinical Guidelines and Reports",
        "Thesis",
        "nonPrint",
        "media",
        "reviews",
        "Reviews, chapters, monographs and editorials",
        "editorials"
      ];
      return types.indexOf(item.type) >= 0 && item.PMID == null;
    }
  );
  ACGME_result.endResult.otherPubs =
    ACGME_result.otherPubs.length +
    getKey(additionalCounts, "Other Publications", 0);

  var isGrandRounds = function (presType) {
    return (
      (presType || "").toLowerCase().indexOf("grand") >= 0 &&
      (presType || "").toLowerCase().indexOf("rounds") >= 0
    );
  };

  ACGME_result.abstractsAndPresentations = filteredFields["presentations"]
    .filter(function (item) {
      return (
        !item.invitedProfessorship &&
        !isGrandRounds(item.presType) &&
        item.presType != "Invited Professorship"
      );
    })
    .concat(
      filteredFields["scholarship"].filter(
        (n) =>
          [
            "Abstracts, Poster Presentations and Exhibits Presented at Professional Meetings",
            "abstracts",
            "otherAbstracts",
            "posters"
          ].indexOf(n.type) >= 0
      )
    );
  ACGME_result.endResult.abstractsAndPresentations =
    ACGME_result.abstractsAndPresentations.length +
    getKey(additionalCounts, "Conference Presentations", 0);

  ACGME_result.otherPresentations = filteredFields["presentations"]
    .filter(function (item) {
      return (
        !!item.invitedProfessorship ||
        item.presType == "Invited Professorship" ||
        isGrandRounds(item.presType)
      );
    })
    .concat(
      filteredFields["scholarship"].filter(
        (n) =>
          n.type ==
          "Professional educational materials or reports, in print or other media"
      )
    );
  ACGME_result.endResult.otherPresentations =
    ACGME_result.otherPresentations.length +
    getKey(additionalCounts, "Other Presentations", 0);

  ACGME_result.chaptersOrTextbooks = filteredFields["scholarship"].filter(
    (n) =>
      [
        "Books/textbooks for the medical or scientific community",
        "Reviews, chapters, monographs and editorials",
        "books",
        "chapters",
        "booksAndChapters"
      ].indexOf(n.type) >= 0
  );
  ACGME_result.endResult.chaptersOrTextbooks =
    ACGME_result.chaptersOrTextbooks.length +
    getKey(additionalCounts, "Chapters / Textbooks", 0);

  ACGME_result.grantsLed = filteredFields["projects"]
    .filter((n) => ["funded", "submitted"].indexOf(n.type) >= 0)
    .filter(function (item) {
      var role = "";
      if (item.role != null && item.role != "Not Selected") role = item.role;
      var isPI =
        role.toLowerCase().indexOf("investigator") >= 0 ||
        role.toLowerCase().indexOf("director") >= 0 ||
        role.toLowerCase().indexOf("pi") >= 0;
      return isPI;
    });
  ACGME_result.endResult.grantsLedList = ACGME_result.grantsLed;
  ACGME_result.endResult.grantsLedNum =
    ACGME_result.grantsLed.length +
    getKey(additionalCounts, "Grant Leadership", 0);
  ACGME_result.endResult.grantsLed =
    getKey(selectOverrides, "Grant Leadership", false) ||
    ACGME_result.grantsLed.length > 0;

  ACGME_result.leadership = filteredFields["committeeService"]
    .concat(filteredFields["editorialActivities"])
    .concat(
      filteredFields["publicPolicy"].filter((n) => n.type == "leadership")
    )
    .concat(filteredFields["investigationLeadership"]);
  ACGME_result.endResult.leadership =
    getKey(selectOverrides, "Leadership or Peer-Review Role", false) ||
    ACGME_result.leadership.length > 0;

  ACGME_result.involvement = {};
  ACGME_result.involvement.research = filteredFields["scholarship"].filter(
    (n) =>
      [
        "Research Investigations",
        "Other peer-reviewed scholarship",
        "Scholarship without named authorship",
        "Proceedings of meetings or other non-peer reviewed scholarship",
        "Letters to the Editor",
        "Professional educational materials or reports, in print or other media",
        "Clinical Guidelines and Reports",
        "Thesis",
        "reviews",
        "Abstracts, Poster Presentations and Exhibits Presented at Professional Meetings"
      ].indexOf(n.type) >= 0
  );
  ACGME_result.endResult.research =
    getKey(selectOverrides, "Research", false) ||
    ACGME_result.involvement.research.length > 0;

  ACGME_result.involvement.grants = filteredFields["projects"].filter(
    (n) => ["funded", "submitted"].indexOf(n.type) >= 0
  );
  ACGME_result.endResult.grants =
    getKey(selectOverrides, "Grants", false) ||
    ACGME_result.involvement.grants.length > 0;

  ACGME_result.involvement.reviews = filteredFields["scholarship"].filter(
    (n) =>
      [
        "Reviews, chapters, monographs and editorials",
        "Books/textbooks for the medical or scientific community",
        "reviews",
        "Case reports"
      ].indexOf(n.type) >= 0
  );
  ACGME_result.endResult.reviews =
    getKey(selectOverrides, "Reviews", false) ||
    ACGME_result.involvement.reviews.length > 0;

  ACGME_result.involvement.committees = filteredFields["committeeService"];
  ACGME_result.endResult.committees =
    getKey(selectOverrides, "Committees", false) ||
    ACGME_result.involvement.committees.length > 0;

  ACGME_result.involvement.innovations = filteredFields[
    "teachingAndEducationInnovations"
  ]
    .concat(filteredFields["technologyAndScienceInnovations"])
    .concat(
      filteredFields["clinicalActivityAndInnovations"].filter(
        (n) => n.type == "Clinical Innovations"
      )
    );
  ACGME_result.endResult.innovations =
    getKey(selectOverrides, "Innovations", false) ||
    ACGME_result.involvement.innovations.length > 0;

  // Teaching is a resident's only ACGME Yes/No
  ACGME_result.involvement.teaching = filteredFields["teaching"]
    .filter(
      (n) =>
        [
          "Teaching of Students in Courses",
          "Formal Teaching of Residents, Clinical Fellows and Research Fellows (post-docs)",
          "Clinical Supervisory and Training Responsibilities",
          "Laboratory and Other Research Supervisory and Training",
          "Formal Teaching of Peers (e.g., CME and other continuing education courses)",
          "external",
          "publicEducation",
          "educationalDev"
        ].indexOf(n.type) >= 0
    )
    .concat(filteredFields["presentations"]);
  ACGME_result.endResult.teaching =
    getKey(selectOverrides, "Teaching", false) ||
    ACGME_result.involvement.teaching.length > 0;

  // No extraction right now
  ACGME_result.endResult.formalCourses = getKey(
    selectOverrides,
    "Formal Courses",
    false
  );
  ACGME_result.endResult.quality = getKey(selectOverrides, "Quality", false);
  ACGME_result.endResult.curricula = getKey(
    selectOverrides,
    "Curricula",
    false
  );

  return ACGME_result;
};
export { serverACGMEResult };

/**
 *
 * @param { { [key: string]: string }} item
 * @param { string } name
 * @param { {
 *            noNL: boolean,
 *            noEscape: boolean
 *           } } opts
 * @returns
 */
var getText = function (item, name, opts) {
  opts = opts || {};
  var text =
    item[name] == null ? "" : (item[name] + (opts.noNL ? "" : "\n")).trim();
  return opts.noEscape ? removeSpecialChar(text) : escapeText(text);
};
export { getText };

/**
 *
 * @param { { effort: { nominator: string,
 *                      num: number,
 *                      per: string },
 *            workTime?: string } } item
 * @param { { noComment: boolean } } opts
 * @returns { string }
 */
var getEffortText = function (item, opts) {
  opts = opts || {};
  if (item == null) return "";
  var nominator = (item.effort || {}).nominator || "hour";
  var parts = [
    item.effort == null || item.effort.num == null || item.effort.num == 0
      ? null
      : item.effort.num +
        " " +
        nominator +
        (item.effort.num == 1 ? "" : "s") +
        " / " +
        item.effort.per,
    item.workTime == null || !!opts.noComment ? null : item.workTime
  ].filter(function (part) {
    return part != null;
  });
  return parts.join(" ");
};
export { getEffortText };

export function checkFormatDefinitions(formats) {
  formats.list.map((format) => {
    // Format config quality checks
    var seenSectionNames = {};
    (formats[format].input || []).map((sectionFormat) => {
      if (_.isFunction(sectionFormat)) return;

      var sectionName = sectionFormat.section ?? sectionFormat.field;
      if (sectionName == null) {
        throw new Error("Missing section name");
      }
      if (seenSectionNames[sectionName] != null) {
        throw new Error("Duplicate section name " + sectionName);
      }
      seenSectionNames[sectionName] = true;

      if (sectionFormat.type == null) {
        throw new Error("Section type not defined");
      }

      if (sectionFormat.type == "obj") {
        if (sectionFormat.items == null) {
          throw new Error("Items missing for section " + sectionName);
        }

        if (sectionFormat.items.find((n) => n.type == "type")) {
          throw new Error("Type not allowed for obj section " + sectionName);
        }
      }
    });
  });
}

/**
 *
 * @param { { key: string, title: string }[] } fields
 * @param { { citationNames: string,
 *            noBold: boolean,
 *            italic: boolean,
 *            bold: boolean,
 *            underline: boolean,
 *            indent: boolean,
 *            center: boolean,
 *            errHandler: (string) => null,
 *            justText: boolean,
 *            noXML: boolean,
 *            font: string,
 *            fontSize: string,
 *            notTable: boolean,
 *            links: { lastId: number, set: {} } }} fontSettings
 * @returns
 */
export function getBiosOutput(fields, fontSettings) {
  // Fields object looks like an array of {key: 'KEY', title: 'TITLE'} objects
  return function (cvDef, { noXML, preview }) {
    fontSettings.preview = preview;
    return fields
      .filter(function (info) {
        return cvDef.bio[info.key] != null;
      })
      .map(function (info) {
        var eduText = cvDef.bio[info.key];
        return {
          name: info.title,
          1: noXML ? eduText : htmlToXML(eduText, fontSettings),
          field: "bio"
        };
      });
  };
}

/**
 *
 * @param { string } field
 * @param { { prefix: string, suffix: string }} opts
 * @returns { (def: {}) => string|null }
 */
export function previewTextField(field, opts) {
  opts = opts || {};
  return function (def) {
    return def[field] == null
      ? null
      : (opts.prefix != null && opts.prefix != "" ? opts.prefix : "") +
          escapeHtml(def[field] || "", { allowTags: true }) +
          (opts.suffix != null && opts.suffix != "" ? opts.suffix : "") +
          "<br>";
  };
}
